module.exports = __webpack_public_path__ + "media/img/logo-transparent-sm-dark-bare-680e26ae327334c2beebbed97864a7e5.png";